import { render, staticRenderFns } from "./MsFiles.vue?vue&type=template&id=07a53ce3"
import script from "./MsFiles.vue?vue&type=script&lang=js"
export * from "./MsFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports